import { v4 as uuidv4 } from 'uuid';
import { AvailabilityEnum } from '../../../products/ProductTypes';
import { OfflineDatabaseSkuKit } from '../../database/offlineDatabase/types/offlineDatabaseKit.types';
import { CreateGridParams } from '../../stores/offlineOrders/types/offlineOrders.actions.types';

export const mountGridItemFromSkuKit = (
  skuKit: OfflineDatabaseSkuKit,
  kitQuantity: number = 1,
): CreateGridParams => {
  const commonParams = {
    id: uuidv4(),
    skuId: skuKit.sku.id,
    quantity: skuKit.quantity * kitQuantity,
    productColorId: skuKit.productColor.id,
  };

  switch (skuKit.availability) {
    case AvailabilityEnum.FUTURE_STOCK:
      return {
        ...commonParams,
        availability: skuKit.availability,
        deliveryWindowId: skuKit.deliveryWindow?.id!,
      };
    case AvailabilityEnum.INFINITE_PRE_ORDER:
    case AvailabilityEnum.MATERIAL_PRE_ORDER:
      if (!skuKit.deliveryWindow?.id) {
        throw new Error(
          `Missing deliveryWindowId for availability [${skuKit.availability}] in skuKit [${skuKit.id}]`,
        );
      }

      return {
        ...commonParams,
        availability: skuKit.availability,
        deliveryWindowId: skuKit.deliveryWindow?.id!,
      };
    case AvailabilityEnum.READY_FOR_DELIVERY:
      return {
        ...commonParams,
        availability: skuKit.availability,
        deliveryWindowId: undefined,
      };
    default:
      throw new Error(`Invalid availability [${skuKit.availability}] for skuKit [${skuKit.id}]`);
  }
};
